<template>
  <div class="order-insurance">
    <div class="header">
      <div class="header-left">
        <img
          class="checkbox"
          src="https://o.666visa.cn/static/ssqpeer/order/icon-checkbox-active-disabled.png"
          alt=""
        />
        <div class="header-title">旅游保险</div>
        <div class="tips">
          <img
            class="icon"
            src="https://o.666visa.cn/static/ssqpeer/order/insurance-icon.png"
            alt=""
          />
          <div class="tips-text">安心出行，生效前可退改</div>
        </div>
      </div>
      <div class="header-right" @click="viewRights">
        <div class="view-rights">查看权益</div>
        <img
          class="icon-view-rights"
          src="https://o.666visa.cn/static/ssqpeer/order/icon-down-blue.png"
          alt=""
        />
      </div>
    </div>
    <div class="insuance-body">
      <div class="product-info-box">
        <div class="product-info-box-top">
          <div class="product-info">
            <plan-item
              v-for="(plan, index) in inner_platform_insurance"
              :key="index"
              :plan="plan"
              :active="inner_platform_insurance_form.insurance_id === plan.insurance_id"
              :tag="`免费赠送${plan.free_days}天`"
              :single-fee="plan.insurance_fee"
              @click.native="selectPlan(plan.insurance_id)"
            >
            </plan-item>
          </div>
          <div class="insurance-right" v-if="current_insurance_item">
            <confirm-module-price-text
              :price="current_insurance_item.insurance_fee"
              :length="order.applicant.length"
            ></confirm-module-price-text>
          </div>
        </div>
        <div class="insurance-form">
          <div class="form-item">
            <div class="item-label insurance-day">保障天数</div>
            <div class="item-content">
              <base-tooltip :show="true" tips="请确认保障天数覆盖您的出行天数" :left="74"></base-tooltip>

              <div class="insurance-day-box">
                <div class="insurance-day">
                  <el-select
                    :value="inner_platform_insurance_form.insurance_day_index"
                    placeholder="请选择"
                    @input="changeDay"
                  >
                    <el-option
                      v-for="(item, index) in current_insurance_item.fee_desc"
                      :key="index"
                      :label="item.key"
                      :value="index"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="over-day"
                  v-if="current_insurance_item.fee_desc[inner_platform_insurance_form.insurance_day_index].step"
                >
                  <el-select
                    :value="inner_platform_insurance_form.over_day_index"
                    placeholder="请选择"
                    @input="changeOverDay"
                  >
                    <el-option
                      v-for="(item, index) in over_day_array"
                      :key="index"
                      :label="item.label"
                      :value="index"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="info-confirm">
      <el-checkbox
        v-model="inner_platform_insurance_form.ensure"
        class="info-confirm-left"
      ></el-checkbox>
      <div class="info-confirm-right">
        我承诺投保信息的真实性，理解并同意
        <a target="_blank" :href="order.product_insurance.clause_url"
          >《保险条款》</a
        >、 <a @click="goDetail('claim')">《投保人申明》</a>、
        <a @click="goDetail('process')">《理赔流程》</a>的全部内容
      </div>
    </div>
  </div>
</template>

<script>
import selectPrice from '../../businessInsurance/popupBox/select';
import PlanItem from './order-insurance-plan.vue';
import Http from '../../../libs/http.js';
import ConfirmModulePriceText from './base/confirm-module-price-text.vue';
import BaseTooltip from './base/base-tooltip.vue';
import insuranceService from '@/services/insurance-service';

export default {
  components: {
    selectPrice,
    PlanItem,
    ConfirmModulePriceText,
    BaseTooltip,
  },
  props: {
    order: {
      type: Object,
      default() {
        return {};
      },
    },
    platform_insurance: {
      type: Array,
      default() {
        return [];
      },
    },
    platform_insurance_form: {
      type: Object,
      default() {
        return {};
      },
    },
    
  },
  data() {
    return {
    };
  },
  created() {},
  computed: {
    inner_platform_insurance: {
      get() {
        return this.platform_insurance;
      },
      set(val) {
        this.$emit('update:platform_insurance', val);
      },
    },
    inner_platform_insurance_form: {
      get() {
        return this.platform_insurance_form;
      },
      set(val) {
        this.$emit('update:platform_insurance_form', val);
      },
    },
    current_insurance_item() {
      return this.inner_platform_insurance.find(item => item.insurance_id === this.inner_platform_insurance_form.insurance_id);
    },
    
    // 每增加一天加收保费 选项
    over_day_array() {
      return insuranceService.getOverDayArray(this.current_insurance_item);
    },
    watchFieldsForPrice() {

      return [
        this.inner_platform_insurance_form.insurance_id,
        this.inner_platform_insurance_form.insurance_day_index,
        this.inner_platform_insurance_form.over_day_index,
      ];
    },
  },
  watch: {
    watchFieldsForPrice: {
      handler() {
        this.getInsurancePrice();
      },
      immediate: true,
    },
  },
  methods: {

    selectPlan(id) {
      let new_insurance_day_index = 0;
      let new_insurance_over_day_index = 0;
      // 当前已经选中, 则需要再切换的时候，找到当前保障天数对应的选项
      // 当前已经选中, 则需要再切换的时候，找到当前保障天数对应的选项
      if (this.current_insurance_item) {

        const currentInsuranceProtectDays = insuranceService.getProtectDays(this.current_insurance_item, this.inner_platform_insurance_form.insurance_day_index, this.inner_platform_insurance_form.over_day_index);
        const newInsuranceInfo = this.inner_platform_insurance.find(item => item.insurance_id === id);
        const { insurance_day_index, over_day_index } = insuranceService.getDayIndexByProtectDays(newInsuranceInfo, currentInsuranceProtectDays);
        new_insurance_day_index = insurance_day_index;
        new_insurance_over_day_index = over_day_index;
      }
      this.inner_platform_insurance_form.insurance_id = id;
      this.inner_platform_insurance_form.insurance_day_index = new_insurance_day_index;
      this.inner_platform_insurance_form.over_day_index = new_insurance_over_day_index;

    },
    changeDay(index) {
      this.inner_platform_insurance_form.insurance_day_index = index;
      this.inner_platform_insurance_form.over_day_index = 0;
    },
    changeOverDay(index) {
      this.inner_platform_insurance_form.over_day_index = index;
    },
    getInsurancePrice(options = {}) {
 
      if (!this.inner_platform_insurance_form.insurance_id) return; 

      return Promise.all(this.inner_platform_insurance.map((item) => {
        const isCurrent = item.insurance_id === this.inner_platform_insurance_form.insurance_id;
        // onlyCurrent目前只给订单提交的时候用，只计算当前选中的保险的价格
        if (options.onlyCurrent && !isCurrent) return null;
        let protect_days = 0;
        // 当前选中的保险，获取保障天数
        if (isCurrent) {
          protect_days = insuranceService.getProtectDays(item, this.inner_platform_insurance_form.insurance_day_index, this.inner_platform_insurance_form.over_day_index);
        } else {
          // 当前保险天数
          const current_insurance_item = this.inner_platform_insurance.find(el => el.insurance_id === this.inner_platform_insurance_form.insurance_id);
          const current_insurance_protect_days = insuranceService.getProtectDays(current_insurance_item, this.inner_platform_insurance_form.insurance_day_index, this.inner_platform_insurance_form.over_day_index);
          // 根据当前保障天数，去找到这个保险的保障天数选项
          const { insurance_day_index, over_day_index } = insuranceService.getDayIndexByProtectDays(item, current_insurance_protect_days);
          protect_days = insuranceService.getProtectDays(item, insurance_day_index, over_day_index);
        }
        return Http.post('/insurance_platform_try', {
          user_order_id: this.order.user_order_id,
          case_code: item.case_code,
          protect_days,
        }).then((res) => {
          item.insurance_fee = res.single_pay_amount;
        });
      }));
    },

    platformInsuranceSubmit() {
      const protect_days = insuranceService.getProtectDays(this.current_insurance_item, this.inner_platform_insurance_form.insurance_day_index, this.inner_platform_insurance_form.over_day_index); 
      return Http.post('/insurance_submit', {
        user_order_id: this.order.user_order_id,
        protect_days,
        case_code: this.current_insurance_item.case_code,
      })
        .then((res) => {
          if (!res.ret) {
            Promise.resolve();
          }
        })
        .catch(e => Promise.reject(e));
    },

    goDetail(type) {
      const routeUrl = this.$router.resolve({
        name: 'BusinessView',
        query: {
          caseCode: this.current_insurance_item.case_code,
          visa_product_id: this.order.visa_product_id,
          user_order_id: this.order.user_order_id,
          type,
        },
      });

      window.open(routeUrl.href, '_blank');
    },
    viewRights() {
      const routeUrl = this.$router.resolve({
        name: 'BusinessView',
        query: {
          caseCode: this.current_insurance_item.case_code,
          visa_product_id: this.order.visa_product_id,
          user_order_id: this.order.user_order_id,
          type: 'detail',
        },
      });

      window.open(routeUrl.href, '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
.order-insurance {
  margin-top: 20px;
  background: #fff;
  line-height: 1;
  .header {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    .header-left {
      display: flex;
      .checkbox {
        margin-right: 12px;
        display: block;
        width: 18px;
        height: 18px;
      }
      .header-title {
        font-size: 20px;
        font-weight: 600;
        color: #2f333d;
        margin-right: 16px;
      }
      .tips {
        display: flex;
        align-items: center;
        padding: 0 18px 0 26px;
        background: linear-gradient(
          270deg,
          rgba(255, 128, 51, 0) 0%,
          rgba(255, 128, 51, 0.1) 100%
        );
        position: relative;
        height: 24px;
        .icon {
          width: 20px;
          height: 19px;
          position: absolute;
          left: -4px;
          top: 50%;
          transform: translateY(-50%);
        }
        .tips-text {
          font-size: 14px;
          color: #ff8033;
          font-weight: 600;
        }
      }
    }
    .header-right {
      display: flex;
      justify-content: flex-end;
      cursor: pointer;
      .view-rights {
        font-size: 14px;
        color: #599fff;
        gap: 6px;
      }
      .icon-view-rights {
        display: block;
        width: 14px;
        height: 14px;
        transform: rotate(270deg);
      }
    }
  }
  .insuance-body {
    margin: 0 24px 16px;
    background: #fafbfc;
    .product-info-box {
      padding:  20px;
      border-radius: 2px;
      .product-info-box-top {
        display: flex;
        justify-content: space-between;
        .product-info {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          gap: 16px;
          padding: 12px 0 20px;
        }
        .insurance-right {
          display: flex;
          flex-direction: column;
          .product-price-box {
            flex-shrink: 0;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            text-align: right;
            .price-value {
              color: #ff8033;
              font-size: 20px;
              font-weight: 600;
              span {
                font-size: 14px;
              }
            }
            .unit {
              color: #5f666e;
              font-size: 14px;
              margin-left: 4px;
            }
          }
          .original-price-box {
            margin-top: 4px;
            margin-left: 12px;
            color: #cccccc;
            font-size: 12px;
            .price {
              text-decoration: line-through;
            }
          }
        }
      }
      .insurance-form {
        border-top: 1px dashed #dee2e6;
        padding: 20px 0 0;
        display: flex;
        flex-wrap: wrap;
        .form-item {
          width: 340px;
          margin-right: 30px;
          display: flex;
          flex-direction: column;
          .item-label {
            color: #2f333d;
            font-size: 16px;
            margin-bottom: 8px;
          }
          .item-content {
            color: #2f333d;
            font-size: 14px;
            .insurance-day-box {
              border: 1px solid #dee2e6;
              border-radius: 2px;
              /deep/ .el-select {
                height: 38px;
                width: 100%;
                .el-input {
                  .el-input__icon {
                    width: 24px;
                    transform: translateY(-50%) rotateZ(180deg) scale(0.7);
                    transform-origin: center center;
                    right: 4px;
                    color: #91999f;
                    &.is-reverse {
                      transform: translateY(-50%) scale(0.7);
                    }
                  }
                  .el-input__inner {
                    border: none;
                    height: 38px;
                    border-radius: 2px;
                    padding-right: 24px;
                    color: #2f333d;
                    font-size: 14px;
                  }
                }
              }
              .over-day {
                /deep/ .el-select {
                  .el-input {
                    .el-input__inner {
                      border-top: 1px solid #dee2e6;
                    }
                  }
                }
              }
            }
            /deep/ .el-date-editor {
              width: 100%;
              .el-icon-date {
              }
              .el-input__inner {
                height: 40px;
                border-radius: 2px;
                padding-right: 24px;
                color: #2f333d;
                font-size: 14px;
              }
            }

            .end-day {
              color: #2f333d;
              font-size: 12px;
              margin-top: 8px;
            }
          }
        }
      }
    }
  }
  .info-confirm {
    font-size: 14px;
    display: flex;
    padding: 0 16px 16px 24px;
    align-items: flex-start;
    .info-confirm-left {
      margin-right: 6px;
      flex-shrink: 0;
      margin-top: 4px;
      /deep/ .el-checkbox__input {
        font-size: 0;
        .el-checkbox__inner {
          width: 12px;
          height: 12px;
          border-radius: 1px;
          &::after{
            left: 3px;
            height: 6px;
            top: 0;
            width: 3px;
          }
        }
      }
    }
    .info-confirm-right {
      font-size: 14px;
      color: #91999F;
      line-height: 24px;
      a {
        color: #599FFF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/order-confirm-insurance.vue